jQuery($ => {
    class Gate {
      constructor(element) {
        this._        = element;
        this._element = $(element);
        this._trigger = $('a[href*="?gate"], a[href*="&gate"]').filter(function() {
          const href      = $(this).attr('href');
          const gateParam = new URLSearchParams(href.split('?')[1]).get('gate');

          return gateParam !== 'false' && gateParam !== false;
        });
        
        this._modalId = this._element.attr('id');
        this._triggerId;
        this._triggerHref;
        this._triggerTarget;
        this._triggerDownload;
        this._ajax = this._element.data('ajax');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );

        if (localStorage.getItem('ug_gate_unlocked') === 'true') {
          this.unlockContent();
        } else {
          this.lockContent();
          
          if ($('body').hasClass('gated')) {
            $(window).on('resize', () => this.lockContent());
            setTimeout(() => $('#content-gate').modal('handleOpen'), 1000);
          }
        }
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        $(window).on('load', this.handleWindowLoad);

        this._element.on('unlock', (event, triggerClickEvent) => this.handleUnlock(triggerClickEvent));
        this._element.on('attemptUnlock', this.handleUnlockAttempt);

        this._trigger.each((_, trigger) => {
          $(trigger).on('mousedown', event => {
            this.handleTriggerClick(event)
          });
          $(trigger).on('keydown', event => {
            this.handleTriggerKeydown(event)
          });
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Lock Content
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      lockContent() {
        if ($('body').hasClass('gated')) {
          $('body, main').css({
            overflow: 'hidden',
            height: '100%',
            width: '100%'
          });
          $('main ~ :not(script)').css({
            zIndex: '0'
          });
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Unlock Content
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      unlockContent() {
        $('body, main').css({
          overflow: '',
          height: '',
          width: ''
        });

        $('main ~ :not(script)').css({
          zIndex: ''
        });

        $('body').removeClass('gated');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Check Is Unlocked
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      checkIsUnlocked() {
        return localStorage.getItem('ug_gate_unlocked') ? true : false;
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Check If Trigger Is Released
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      checkIsTriggerReleased = trigger => {
        const $trigger   = $(trigger);
        const isReleased = $trigger.hasClass('--released');

        return isReleased;
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Check If Trigger Is Unlocked
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      checkIsTriggerUnlocked = trigger => {
        if (!this.checkIsUnlocked()) return;
        return this.checkIsTriggerReleased($(trigger));
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Window Load
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleWindowLoad = () => {
        if (this.checkIsUnlocked()) {
          this.releaseTriggers();
        } else {
          this.setTriggerAttrs();
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Set Trigger Aria Controls
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      setTriggerAttrs = () => {
        this._trigger.each((_, trigger) => {
          if (this._modalId !== undefined) {
            $(trigger).attr('aria-controls', this._modalId);
          }

          if (!$(trigger).attr('id')) {
            const uid       = String(Math.floor(Math.random() * 100000)).padStart(5, '0');
            const triggerId = `gateTrigger-${uid}`;

            $(trigger).attr('id', triggerId);
          }
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Set Local Storage
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      setLocalStorage = (setToUnlocked = true) => {
        localStorage.setItem('ug_gate_unlocked', setToUnlocked);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Release Triggers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      releaseTriggers = () => {
        this._trigger.each((_, trigger) => {
          $(trigger).addClass('--released');
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Trigger Mousedown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleTriggerClick = event => {
        if (this.checkIsTriggerUnlocked(event.currentTarget)) return;

        event.preventDefault();

        const $trigger = $(event.currentTarget);

        this._triggerId       = $trigger.attr('id');
        this._triggerHref     = $trigger.attr('href');
        this._triggerTarget   = $trigger.attr('target');
        this._triggerDownload = $trigger.is('[download]');

        this.handleModalToggle();

        this._element.trigger('openGate', {
          id       : this._triggerId,
          href     : this._triggerHref,
          target   : this._triggerTarget,
          download : this._triggerDownload
        });
      }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Trigger Keydown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleTriggerKeydown = event => {
      switch (event.key) {
        case 'Enter':
        case 'spacebar':
        case ' ':
          if (this.checkIsTriggerUnlocked(event.currentTarget)) return;

          event.preventDefault();

          const $trigger = $(event.currentTarget);

          this._triggerId       = $trigger.attr('id');
          this._triggerHref     = $trigger.attr('href');
          this._triggerTarget   = $trigger.attr('target');
          this._triggerDownload = $trigger.is('[download]');

          this.handleModalToggle();

          this._element.trigger('openGate', {
            id       : this._triggerId,
            href     : this._triggerHref,
            target   : this._triggerTarget,
            download : this._triggerDownload
          });
          break;
      }
    }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Modal Open
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleModalOpen = event => {
        $('.m-modal--open').each(function() {
          $(this).modal('handleClose');
        });

        this._element.modal('setControlledby', this._triggerId);
        this._element.modal('handleOpen');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Modal Close
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleModalClose = () => {
        this._element.modal('handleClose');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Modal Toggle
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleModalToggle = () => {
        if (this._element.hasClass('m-modal--open')) {
          this.handleModalClose();
        } else {
          this.handleModalOpen();
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Unlock
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleUnlock = (triggerClickEvent = false) => {
        this.setLocalStorage();
        this.releaseTriggers();

        if (triggerClickEvent) {
          $(`#${this._triggerId}`)[0].click();
        }

        if ($('body').hasClass('gated')) {
          this.unlockContent();
          setTimeout(() => this._element.removeClass('m-modal--open'), 1000);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Unlock Attempt
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleUnlockAttempt = (event, formData) => {
        const isUnlocked = this.checkIsUnlocked();

        if (!isUnlocked) {
          let data = {
            action: 'ug_unlock_gate',
            data: {
              gateId: this._modalId,
              trigger: {
                url      : this._triggerHref,
                target   : this._triggerTarget,
                download : this._triggerDownload
              },
              form: formData
            }
          }
  
          $.ajax({
            url: this._ajax,
            type: 'POST',
            data,
            success: this.handleResponse.bind(this)
          });
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Response
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleResponse = response => {
        const isSuccess = response.success === undefined || response.success;
        const data      = response.data || {};

        if (isSuccess) {
          this.handleRequestSuccess(data);
        } else {
          this.handleRequestError(data);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Request Success
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleRequestSuccess = data => {
        this._element.find('.m-modal__content').html(data);
        this.handleUnlock(true);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Request Error
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleRequestError = data => {
        console.error('Status: Filter ajax request failed', data);
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.gate = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].gate = new Gate(_[i], opt);
        else
          ret = _[i].gate[opt].apply(_[i].gate, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-gate').gate();
});